import { userProfile } from 'utils/auth';

export const GUIDANCE_TOUR_DRAWER_Z_INDEX = 10000;
export const GUIDANCE_TOUR_DRAWER_WIDTH_PX = 440;
export const GUIDANCE_TOUR_DRAWER_SLIDE_TIMEOUT_MS = 320;

const OLD_LAYOUT_HEADER_HEIGHT_PX = 64;
const OLD_LAYOUT_SIDEBAR_WIDTH_PX = 72;
const NEW_LAYOUT_SIDEBAR_WIDTH_PX = 256;

export type GuidanceTourLayoutInsets = {
  top: number;
  left: number;
  drawerWidth: number;
};

export function getGuidanceTourLayoutInsets(): GuidanceTourLayoutInsets {
  const user = userProfile(false);
  const usesOldLayout = user?.old_layout !== false;

  if (usesOldLayout) {
    return {
      top: OLD_LAYOUT_HEADER_HEIGHT_PX,
      left: OLD_LAYOUT_SIDEBAR_WIDTH_PX,
      drawerWidth: GUIDANCE_TOUR_DRAWER_WIDTH_PX,
    };
  }

  return {
    top: 0,
    left: NEW_LAYOUT_SIDEBAR_WIDTH_PX,
    drawerWidth: GUIDANCE_TOUR_DRAWER_WIDTH_PX,
  };
}
